module.exports = __webpack_public_path__ + "static/media/icefields-7.82a52763.jpg";